import React from "react";
import { Box, Grid, Typography, makeStyles } from "@material-ui/core";
import clsx from 'clsx';
import { Alert } from "@material-ui/lab";

const useStyles = makeStyles((theme) => ({
    root: {
        marginBottom: theme.spacing(2),
    },
    header: {
        display: "flex",
        alignItems: "center",
        marginTop: theme.spacing(1),
    },
    avatar: {
        borderRadius: "50%",
        width: 80,
        height: 80,
        objectFit: "cover",
        marginRight: theme.spacing(2),
    },
    name: {
        fontWeight: 600,
        fontSize: "14px",
    },
    base: {
        color: "#777",
    },
    statusBox: {
        marginTop: theme.spacing(2),
        borderRadius: 6,
        padding: theme.spacing(1.2),
        textAlign: "center",
        fontWeight: 500,
    },
    alert: {
        width: '100%',
        justifyContent: 'center',
        fontWeight: theme.typography.fontWeightRegular
    },
    amber: {
        color: '#FFB300',
        backgroundColor: `rgba(255, 179, 0, 0.15)`
    },
    error: {
        color: '#DF0011',
        backgroundColor: `rgba(223, 0, 17,0.15)`
    },
    success: {
        color: '#4FC605',
        backgroundColor: `rgba(79,198,5, 0.15)`
    },
    white: {
        backgroundColor: `#FFF`
    }
}));

export default function UserProfileHeader({
    profileImage,
    userName,
    base,
    text,
    statusColor = "#d4f8d4",
    statusTextColor = "#2e7d32",
}) {
    const classes = useStyles();

    return (
        <Grid container className={classes.root}>
            <Grid item xs={12}>
                <Typography variant="body2" color="textSecondary">
                    Showing details for
                </Typography>

                <div className={classes.header}>

                    <img
                        src={profileImage || "https://cdn4.iconfinder.com/data/icons/glyphs/24/icons_user2-128.png"}
                        alt="Profile"
                        className={classes.avatar}
                    />
                    <div>
                        <Typography color="primary" variant="body1" className={classes.name}>
                            {userName || "-"}
                        </Typography>
                        <Typography variant="body1" className={classes.name}>
                            {base || ""}
                        </Typography>
                    </div>
                </div>
            </Grid>
            <Grid item xs={12}>
                <Box display="flex" justifyContent="center" mt={2}>
                    <Alert className={text ? clsx(classes.alert, classes[statusTextColor]) : clsx(classes.alert, classes.white)} icon={false} severity={statusColor} color={statusColor}>
                        {text}
                    </Alert>
                </Box>
            </Grid>
        </Grid>
    );
}
